import React from "react";

const ContactPage = () => {
  return (
    <div>contact page</div>
  );
}

export default ContactPage;
